import React, { useContext, useEffect, useState } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';

import { AppContext, ModalContext, CustomFooter } from 'commons-ui';
import { GAME_NAME_OPTIONS, GAME_NAMES } from 'pages/constants';
import useService from './useService';
import { ITournamentDetails } from '../types';

interface GameplayTimelineListProps {
	getGameplayTimelineData: () => any;
	tournamentDetails: ITournamentDetails;
}
const BUTTON_LABELS = {
	AGREE: 'Confirm',
	DISAGREE: 'Back'
};

const useTimelineList = ({ getGameplayTimelineData, tournamentDetails }: GameplayTimelineListProps) => {
	const [timelineIsCollapsed, setTimelineIsCollapsed] = useState<boolean>(true);
	const { setModalConfig } = useContext(ModalContext);
	const [timelineData, setTimelineData] = useState<any>();
	const [dataFetchComplete, setDataFetchComplete] = useState<boolean>(false);
	const [showLoader, setShowLoader] = useState<boolean>(false);
	const { showAlert } = useContext(AppContext);
	const { gameName } = tournamentDetails;
	const { getGameAndNetworkLogs } = useService();
	const onAgreeHandler = async () => {
		setModalConfig({ isOpen: false });
		setTimelineIsCollapsed(false);
	};
	const onDisAgreeHandler = () => {
		setModalConfig({ isOpen: false });
	};

	const setTimelineIsCollapsedHandler = (flag: boolean) => {
		if (
			gameName === GAME_NAME_OPTIONS[GAME_NAMES.LUDO] ||
			gameName === GAME_NAME_OPTIONS[GAME_NAMES.TURBO] ||
			gameName === GAME_NAME_OPTIONS[GAME_NAMES.NINJA]
		) {
			if (flag || dataFetchComplete) {
				setTimelineIsCollapsed(flag);
			} else {
				setModalConfig({
					isOpen: true,
					header: 'Data Fetch Confirmation',
					content:
						'Refund suggestion feature is available for this game. Use it only if you are unsatisfied with refund suggestion result because this is a high cost operation, Do you want to continue ?',
					footer: (
						<CustomFooter
							agreeLabel={BUTTON_LABELS.AGREE}
							disagreeLabel={BUTTON_LABELS.DISAGREE}
							onAgreeClick={onAgreeHandler}
							onDisagreeClick={onDisAgreeHandler}
						/>
					)
				});
			}
		} else {
			setTimelineIsCollapsed(flag);
		}
	};

	const copyToClipboard = (event: any) => {
		event.preventDefault();
		event.stopPropagation();
		navigator.clipboard.writeText(JSON.stringify(_get(timelineData, 'data', []), null, 2));
	};

	const handleDatalistFetchData = () => {
		return timelineData;
	};

	useEffect(() => {
		const fetchRowData = async () => {
			try {
				setShowLoader(true);
				let fetchedData = await getGameplayTimelineData();
				if (
					(_isNil(fetchedData) || _isEmpty(fetchedData.data)) &&
					(gameName === GAME_NAME_OPTIONS[GAME_NAMES.LUDO] ||
						gameName === GAME_NAME_OPTIONS[GAME_NAMES.TURBO] ||
						gameName === GAME_NAME_OPTIONS[GAME_NAMES.NINJA] ||
						gameName === GAME_NAME_OPTIONS[GAME_NAMES.SNLT] ||
						gameName === GAME_NAME_OPTIONS[GAME_NAMES.LUDONX] ||
						gameName === GAME_NAME_OPTIONS[GAME_NAMES.TC] ||
						gameName === GAME_NAME_OPTIONS[GAME_NAMES.HC])
				) {
					fetchedData = await getGameAndNetworkLogs(tournamentDetails);
				} else {
					fetchedData = await getGameplayTimelineData();
				}
				setTimelineData({ rowCount: fetchedData.rowCount, data: fetchedData.data });
			} catch (error: any) {
				showAlert(_get(error, 'error', 'Error while fetching data'), { type: 'error' });
			} finally {
				setShowLoader(false);
				setDataFetchComplete(true);
			}
		};

		if (!timelineIsCollapsed && !dataFetchComplete) {
			fetchRowData();
		}
	}, [timelineIsCollapsed, dataFetchComplete]);

	return {
		timelineIsCollapsed,
		setTimelineIsCollapsedHandler,
		dataFetchComplete,
		showLoader,
		copyToClipboard,
		handleDatalistFetchData
	};
};

export default useTimelineList;
